module.exports = __webpack_public_path__ + "static/img/qrCodeEn.ad1cbcc2.png";